var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("Loading... "),_c('a',{attrs:{"href":"https://tiktok.com/@labyhelp_addon"}},[_vm._v("Dont work? click here")])])])}]

export { render, staticRenderFns }